module.exports = __webpack_public_path__ + "static/media/news1.9454eabf.png";